
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown, Form} from "react-bootstrap";
import Select from "react-select";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus, Waveform, Moon, MapPinSimple } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import vindrApi from "../utils/vindrapi";
import {format_power} from "../utils/functions";
import EditNow from "../components/EditNow";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import clickableMarker from "../utils/clickableMarker";

class ToolSensor {

	sensorIcon = '<svg xmlns="http://www.w3.org/2000/svg" class="sensor" width="16" height="16" fill="currentColor"  viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><circle cx="128" cy="72" r="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="232" x2="128" y2="120" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>';
	
	tabIndex			= null;
	highlightedOnList	= [];
	hiddenSensors		= [];
	allHidden			= false;
	
	modified			= false;
	contextMenu			= null;
	
	ADD					= 1;
	REMOVE				= 2;
	
	constructor(p, mode) {
		this.tc			= p;
		if (!ToolSensor.sensors){
			ToolSensor.sensors		= [];
			ToolSensor.tabIndex		= null;
		}
		
//		switch(mode){
//			case this.REMOVE: 
//				this.setRemoveSensorListener();
//				break;
//			case this.ADD: 
//				this.setAddSensorListener();
//				break;
//		}
		
	}
	setRemoveSensorListener(){
		
		this.tc.map.getContainer().classList.add("cursor-delete-sensor");
		this.tc.map.on('click', this.removeSensor);
	}
	setAddSensorListener(){
		this.tc.map.getContainer().classList.add("cursor-add-sensor");
		this.tc.map.on('click', this.addSensor);
	}
	update(){
		

	}
	init(){
		this.display();
		this.drawSensors();
		this.setEventHandlers();
	}
	exit(){
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(ToolSensor.tabIndex);
		ToolSensor.tabIndex = null;
		this.clearSensors();
		this.removeEventHandlers();
		delete ToolSensor.sensors;
	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		this.tc.map.on('scenario.updated', this.drawSensors);
		this.setAddSensorListener();
		this.tc.map.on('contextmenu', this.handleRightClick);
		
		ToolSensor.sensors.forEach((s)=>this.setSensorEvents(s));
		
		
	}
	setSensorEvents = (s)=>{
		const d = s._element.querySelector(".drop");
		
		d.addEventListener("mouseenter", this.handleSensorEnter);
		d.addEventListener("mouseleave", this.handleSensorLeave);
		s.on('dragend', this.handleSensorMove);
		s.onClick(this.handleSensorClick);
	}
	removeEventHandlers(){
		if(!this.tc)
			return;
		
		this.tc.map.off('click', this.removeSensor);
		this.tc.map.off('click', this.addSensor);
		this.tc.map.off('scenario.updated', this.drawSensors);
		
		this.tc.map.getContainer().classList.remove("cursor-add-sensor");
		this.tc.map.getContainer().classList.remove("cursor-delete-sensor");
		this.tc.map.off('contextmenu', this.handleRightClick);
		
		ToolSensor.sensors.forEach((s)=>{
			const d = s._element.querySelector(".drop");
			
			d.removeEventListener("mouseenter", this.handleSensorEnter);
			d.removeEventListener("mouseleave", this.handleSensorLeave);
			s.off('dragend', this.handleSensorMove);
			s.onClick(()=>{});
		});
		
		
	}
	addSensor = (e)=>{
		
		this.closeContextMenu();
		
		if(this.tc.secondaryHandler)
			return;
		
		if(e.originalEvent.target.closest(".drop"))
			return; //avoid placing sensors where we already have one
		
		e.originalEvent.stopPropagation();
		
		var newSensor = {
			"geometry": {
				"coordinates": [e.lngLat.lng, e.lngLat.lat],
				"type": "Point"
			},
			"nsaid": 'temp_'+Math.random().toString(36).substr(2, 9),
			"name": "Sensor "+(this.tc.scenario.nsas.length+1),
			"type": "Feature",
			"shadow": {"hours":0,"minutes":0},
			"decibel": 0
		}
		
		this.tc.scenario.nsas.push(newSensor);
		this.drawSensors();

		this.tc.scenario.modified = 1;
		this.tc.setScenario(this.tc.scenario);
		this.tc.record().add(this.tc.scenario);
		
		let event = {
			scenario:this.tc.scenario, 
			sensor:newSensor
		};
		this.tc.map.fire("addSensor", event);
		
	}
	removeSensor = (e, sId) =>{
		
		e?.originalEvent?.stopPropagation();
		var	sensorId;
		
		if(sId){
			sensorId = sId;
		}
		else {
			var elem = e.originalEvent.target.closest(".sensor-marker");
			
			sensorId = elem.dataset.nsaid;
		}	
		if(!sensorId)
			return

		this.updateSensor(sensorId, null);
		
		this.drawSensors();

		this.tc.record().add(this.tc.scenario);
		
		let event = {
			scenario:this.tc.scenario, 
			sensor:sensorId
		};
		
		this.tc.map.fire("removeSensor", event);
		this.display();
	}
	
	updateSensor = (nsaid, coordinates) => {
		
		if(!this.tc.scenario || !this.tc.scenario.scenario_id)
			return;
		var i = this.tc.scenario.nsas.findIndex((elem)=>elem.nsaid == nsaid);
		if(i>-1){
			if(coordinates){
				this.tc.scenario.nsas[i].geometry.coordinates = coordinates;
				this.tc.record().add(this.tc.scenario);
			}
			else{
				delete this.tc.scenario.nsas[i].geometry;
			
				//check if sensor was new, if so don't send object
				if(typeof this.tc.scenario.nsas[i].nsaid != 'number')
					this.tc.scenario.nsas.splice(i, 1);
			}
			this.tc.scenario.modified = 1;
			
			this.tc.setScenario(this.tc.scenario);
		}
	}
	addSensorName(sensor){
		var input = document.createElement('span');
		input.contentEditable = this.tc.scenario.scenario_id ? "true" : "false";
		input.innerText = sensor.name ? sensor.name : 'Sensor '+sensor.nsaid;
		input.className = "sensor-input";
		input.onclick = (e)=>{e.stopPropagation(); e.target.focus()};
		input.ondblclick = (e)=>{e.stopPropagation(); e.target.focus()};
		input.onkeydown = input.ondrag = input.ondragstart = input.onmousedown = (e)=>{e.stopPropagation();};
		input.dataset.nsaid = sensor.nsaid;
		input.onblur = (e)=>{this.updateSensorName(e.target.innerText, e.target.dataset.nsaid);}
		
		const el = document.createElement('div');
		el.className = 'sensor-marker-name';
		el.appendChild(input);
		return el;
	}
	updateSensorName(name, nsaid, refresh){
		
		if(!this.tc.scenario || !this.tc.scenario.scenario_id)
			return;
		var i = this.tc.scenario.nsas.findIndex((elem)=>elem.nsaid == nsaid);
		if(i>-1){
			this.tc.scenario.nsas[i].name = name ? name : 'Sensor '+nsaid;
			
			//don't update in API if sensor is temporary
			if(!isNaN(nsaid) && vindrApi.updateSensorName)
				vindrApi.updateSensorName({name:name}, this.tc.scenario.projectid, this.tc.scenario.scenario_id, nsaid);
			
			this.tc.scenario.modified = 1;
			this.tc.record().add(this.tc.scenario);
			//this.setScenario(this.scenario);
		}
		
		if(refresh)
			this.drawSensors();
	}
	drawSensors = () => {
		var scenario = this.tc.scenario;
		this.clearSensors();
		
		scenario.nsas.forEach((sensor)=>{
			
			//check if sensor was deleted
			if(!sensor.geometry)
				return;
			
			const el = document.createElement('div');
			el.className = 'sensor-marker';
			el.id = 'sensor-marker-'+sensor.nsaid;
			el.dataset.nsaid = sensor.nsaid;
			var drop = document.createElement('div');
			drop.className="drop";
			drop.innerHTML = this.sensorIcon + this.tc.draw.trash;
			el.appendChild(drop);
			el.appendChild(this.addSensorName(sensor));
	
			const marker = new clickableMarker({
				draggable: !!(scenario.scenario_id),
				element:el,
				anchor:'bottom'
			})
			.setLngLat(sensor.geometry.coordinates)
			.addTo(this.tc.map);

			this.setSensorEvents(marker);
			ToolSensor.sensors.push(marker);
		});	
	}
	handleSensorMove = (e)=>{
		
		var id = e.target.getElement().dataset.nsaid;
		var coords = e.target.getLngLat();
		
		this.updateSensor(id, [coords.lng, coords.lat]);
	}
	clearSensors(){
		ToolSensor.sensors.forEach((s) => {
			s.remove();
		});
		ToolSensor.sensors = [];
	}
	handleSensorEnter = (e) => {
		e.stopPropagation();
		
		const sensorId = e.target.parentNode.dataset.nsaid;
		
		e.target.parentNode.classList.add("active");
		this.tc.map.getContainer().classList.remove("cursor-add-sensor");
		this.tc.map.getContainer().classList.add("cursor-pointer");
		
		this.highlightOnList(sensorId);
		clearTimeout(this.hoverLeaveTimeout);
	}
	handleSensorLeave = (e) => {
		e.stopPropagation();
		
		const sensorId = e.target.parentNode.dataset.nsaid;
		
		
		//timeout to stop flicker when dragging
		clearTimeout(this.hoverLeaveTimeout);
		this.hoverLeaveTimeout = setTimeout(()=>{
			e.target.parentNode.classList.remove("active");
			this.tc.map.getContainer().classList.remove("cursor-pointer");
			this.tc.map.getContainer().classList.add("cursor-add-sensor");
			this.deHighlightOnList(sensorId);
		}, 100);
		
	}
	unselectAll(){
		ToolSensor.sensors.forEach((s)=>{s._element.classList.remove("selected");});
	}
	select(id){
		ToolSensor.sensors.forEach((s)=>{
			if(s._element.dataset.nsaid && s._element.dataset.nsaid == id)
				s._element.classList.add("selected");
		});
	}
	handleSensorClick = (elem)=>{
		
		const nsaid = elem.dataset.nsaid;
		this.unselectAll();
		this.currentSensor = this.tc.scenario.nsas.find((s)=>{return s.nsaid == nsaid});
		elem.classList.add("selected");
		
		this.display();
	}
	tName(row, index){
		return row.name != '' ? row.name : 'Sensor '+ (index+1);
		
	}
	highlightOnMap = (row) => {
		document.querySelector("#sensor-marker-"+row.nsaid)?.classList?.add("active");
	}
	
	deHighlightOnMap = (row) => {
		document.querySelector("#sensor-marker-"+row.nsaid)?.classList?.remove("active");
	}
	
	idString(id){
		return isNaN(id) ? id : id.toString();
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(this.idString(id));
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];

		this.display();
	}
	deHighlightOnList = (id) => {

		const index = this.highlightedOnList.indexOf(this.idString(id));
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		this.display();
	}
	
	
	handleRowClick = (row)=>{
		
		
		this.unselectAll();
		this.currentSensor = this.tc.scenario.nsas.find((s)=>{return s.nsaid == row.nsaid});
		this.unselectAll();
		this.select(row.nsaid);
		
		this.display();
	}
	setHideAll(value){
		this.allHidden = value;
		this.display();
	}
//	getTypes = ()=>{
//			
//		const dataRequests = [
//			vindrApi.getSensorTypes(),
//		];
//			
//		return Promise.all(dataRequests)
//		.then((res)=>{
//			this.sensorTypes = res[0];
//		})		
//	}

	closeContextMenu() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".sensorModeContextMenu")){
			a.remove();
		}
		
		
	}
	handleRightClick = (e)=>{
		e.originalEvent.preventDefault();
		const el = e.originalEvent.target.closest(".sensor-marker");
		
		if(!el)
			return; //avoid placing annotations where we already have one
		
		
		var wrp = document.createElement("div");
		wrp.className = "sensorModeContextMenu";
		wrp.style.left = e.point.x+'px';
		wrp.style.top = e.point.y+'px';
		
		this.closeContextMenu();
		
		
		
		this.tc.map.getContainer().appendChild(wrp);
		

		ReactDOM.createRoot(wrp).render(this.contextMenu(e, el.dataset.nsaid));
		
		
		
		
	}
	
	handleHideAllSensors = () => {
		if(!this.allHidden){
			this.hiddenSensors = this.tc.scenario.nsas.map((t)=>{
				this.handleToggleSensor(t.nsaid, true, true);
				return t.nsaid;
			});
			this.allHidden = true;
		}
		else{
			const copy = this.hiddenSensors.slice(0);
			copy.forEach((t)=>{this.handleToggleSensor(t, false, true);});
			this.hiddenSensors = [];
			this.allHidden = false;
			
		}
		this.display();
	}
	handleToggleSensor = (nsaid, force, dontRefresh) => {
		
		
		const hidden = document.querySelector("#sens_"+nsaid).classList.toggle("opacity-25", typeof force == "boolean" ? force : undefined);
		if(!hidden){
			const index = this.hiddenSensors.indexOf(nsaid);
			if (index > -1) {
				this.hiddenSensors.splice(index, 1);
				this.allHidden = false;
			}
		}
		else{
			this.hiddenSensors.push(nsaid);
		}

		if(this.hiddenSensors.length == this.tc.scenario.nsas.length){
			this.allHidden = true;
		}
		
		var global = document.querySelector("#sensor-marker-"+nsaid).classList.toggle("d-none", hidden);
		
			
		if(!dontRefresh)
			this.display();
		
	}

	handleRemoveSensor = (e, sensorId) => {
		this.removeSensor(e, sensorId);
		this.display();
		return true;
	}
	handleSelect = (e, row) => {
		const id = "nsaid";
		if(!this.selected)
			this.selected = [];
		const idx = this.selected.findIndex((a)=>{return a[id] == row[id]});
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	handleBulkDelete = () => {
		if(!this.selected || !this.selected.length)
			return;
		this.selected.forEach((row) => {
			this.removeSensor(null, row.nsaid);
		});
		this.selected = [];
		this.display();
	}
	handleUpdateName(newName, id){
		this.updateSensorName(newName, id, true);
		this.display();
	}
	handleEditSensor(e, nsaid){
		document.getElementById('edit-static-sensor-'+nsaid).dispatchEvent(new MouseEvent("dblclick", {'view': window,'bubbles': true,'cancelable': true}))
	}
	handleExitDetail = (e)=>{
		this.currentSensor = null;
		this.unselectAll();
		this.display();
	}
	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(this.idString(row.nsaid));
	}
	
	contextMenuAdd(map_event){
		return (
			<button className="btn" onClick={(e)=>{this.addSensor(map_event); this.closeContextMenu();}}><Plus size={20} /> Add Sensor</button>
		);
	}
	contextMenu = (map_event, nsaid)=>{
		return (
			<>
				<button className="btn" onClick={(e)=>{this.handleEditSensor(map_event, nsaid); this.closeContextMenu();}}><PencilSimple size={20} /> Edit name</button>
				<button className="btn" onClick={(e)=>{this.removeSensor(map_event); this.closeContextMenu();}}><Trash size={20} /> Remove Sensor</button>
			</>
		);
	}
	formatNoise(val){
		
		return (isNaN(val) || val == "" ? 0 : parseFloat(val)) + ' dB';
	}
	
	
	formatShadow(shadow){
		
		return shadow.hours+'h '+shadow.minutes+'m / yr';
	}
	
	display(){
		if(this.tc.serviceBar.current)
			ToolSensor.tabIndex =	this.tc.serviceBar.current.inject(this.currentSensor ? this.renderDetail() : this.render(), ToolSensor.tabIndex);
	}
	renderDetail(){
		
		if(!this.currentSensor)
			return;
		
		return (
			
			<div className={"project-sensors "}>
				<div className="title">
					{this.currentSensor.name}
					<span onClick={(e)=>{this.handleExitDetail()}} 	className="btn btn-close alt btn-sm float-end"><X size={16} /></span>
				</div>
				<div className="scroll">

					<div className="separator">
						<span>About this sensor</span>
					</div>
					<div className="sensor-detail">


						<Row className="basic-info mb-2">
							<Col xs="12">
								<MapPinSimple size={16} />
								<span>Name: </span>
								<EditNow id={'sensor-'+this.currentSensor.nsaid} value={this.currentSensor.name} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, this.currentSensor.nsaid)}} />
								
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Moon size={16} />
								<span>Shadow: </span>
								
								{this.formatShadow(this.currentSensor.shadow)}
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Waveform size={16} />
								<span>Noise: </span>
								
								{this.formatNoise(this.currentSensor.decibel)}
							</Col>
						</Row>
					</div>
				</div>

			</div>	
			
		);
		
	}
	
	render(){
		
		
		var sensors = this.tc.scenario.nsas ? this.tc.scenario.nsas.filter((t) => t.geometry ? true : false) : (this.tc.scenario.nsas = []);
		return (
			
			<div className={"project-sensors "}>
				<div className="title">
					Sensors
					{/*<span onClick={(e)=>{this.tc.exit()}} 	className="btn btn-close alt btn-sm float-end"><X size={16} /></span>*/}
				</div>
				<div className="scroll">
					<div className="content p-0">

						<DataTable
							data={sensors}
							columns={
								[
									{
										name:<Eye onClick={this.handleHideAllSensors} className={""+(this.allHidden ? 'opacity-25' : '')} size={16} />,
										id:'userid',
										selector: row => row.userid,
										format: (row) =>	(<Eye onClick={(e)=>{this.handleToggleSensor(row.nsaid, undefined, false)}} id={"sens_"+row.nsaid} data-id={row.nsaid}  className={""+(this.hiddenSensors.includes(row.nsaid) || this.allHidden ? 'opacity-25' : '')} size={16} />),
										width:"28px",
										style: {
											padding: '0',
										}
									},
									{
										name:'',
										selector: this.tName,
										format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+row.nsaid} checked={this.selected && this.selected.some((a)=>a.nsaid == row.nsaid)} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
										width:"25px",
										style: {
											padding: '0px !important',
										}
									},
									{
										name:'NAME',
										selector: this.tName,
										format: (row,index) => (<EditNow id={'sensor-'+row.nsaid} value={this.tName(row,index)} onClick={(e)=>{this.handleRowClick(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, row.nsaid)}} />),
										sortable:true,
										width:"100%",
									},
									{
										name:'SHADOW',
										selector: (row) => {return row.shadow.hours+(row.shadow.hours/100)},
										format: (row,index) => (this.formatShadow(row.shadow)),
										sortable:true,
										width:"80px",
										center: "true",
									},
									{
										name:'NOISE',
										selector: (row) => {return row.decibel},
										format: (row,index) => (this.formatNoise(row.decibel)),
										sortable:true,
										width:"70px",
										center: "true",
									},
									{
										name:'',
										cell: row => (
											<div className="context-menu" data-tag="allowRowEvents">
													<Dropdown className="minimal">
														<Dropdown.Toggle className="p-0 px-1" variant="default">
															<DotsThreeVertical size={16} />
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleEditSensor(e, row.nsaid);   }}><PencilSimple size={16} /> Edit name</Dropdown.Item>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleRemoveSensor(e, row.nsaid); }} className="text-danger" ><Trash size={16} /> Remove sensor</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
											</div>
										),
										width:"20px"
										
									}
								]
							}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={this.highlightOnMap}
							onRowMouseLeave={this.deHighlightOnMap}
							onRowClicked={this.handleRowClick }
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={

								<Row className="p-0 py-3 m-0">

									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no sensors placed in this scenario.
									</Col>



								</Row>
							}
						/>

						{this.selected && !!this.selected.length &&
							<Row className="p-3 batch-action">
								<Col xs="6">
									{this.selected.length} Items selected
								</Col>
								<Col xs="6 text-end">
									<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
								</Col>
							</Row>
						}
					</div>

				</div>
			</div>	
			
		);
		
	}
}

export default ToolSensor;